import React from 'react';

import { Menu } from 'antd';
import { RibbonButton } from 'common/components';
import { EditOutlined } from '@ant-design/icons';
import { useGlobalModal } from 'hooks';

const ExportBulkProductOverlay = ({ disabled }) => {
  const { openModal, MODAL_NAMES } = useGlobalModal();

  const onClickExportButton = () => {
    openModal(MODAL_NAMES.EXPORT_BULK_PRODUCT_OVERLAY);
  };

  return (
    <Menu.Item style={{ backgroundColor: 'inherit' }}>
      <RibbonButton
        className='button-item-dropdown'
        icon={<EditOutlined />}
        label={'Export Selected Product Overlay(s)'}
        size='small'
        disabled={disabled}
        onClick={onClickExportButton}
      />
    </Menu.Item>
  );
};

export default ExportBulkProductOverlay;
